import React from 'react';
import { IconProps } from '../types';

export const CampaignsIcon = ({ color }: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
        <g clipPath="url(#clip0_9520_39642)">
            <path
                d="M13.509 19.161L16.809 27.341C17.0723 27.9965 17.0646 28.7297 16.7876 29.3796C16.5107 30.0294 15.9872 30.5428 15.332 30.807C14.6763 31.07 13.9431 31.0622 13.2932 30.7853C12.6432 30.5084 12.1296 29.985 11.865 29.33L6.82703 16.94"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
            />
            <path
                d="M25.5 23C28.5376 23 31 18.0751 31 12C31 5.92487 28.5376 1 25.5 1C22.4624 1 20 5.92487 20 12C20 18.0751 22.4624 23 25.5 23Z"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M24 9C24.7956 9 25.5587 9.31607 26.1213 9.87868C26.6839 10.4413 27 11.2044 27 12C27 12.7956 26.6839 13.5587 26.1213 14.1213C25.5587 14.6839 24.7956 15 24 15"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="square"
            />
            <path
                d="M24.412 1.21503L4.00001 8.00003C3.11503 8.21788 2.33271 8.73529 1.78586 9.46441C1.23902 10.1935 0.961356 11.0894 1.00001 12C0.961356 12.9106 1.23902 13.8065 1.78586 14.5356C2.33271 15.2648 3.11503 15.7822 4.00001 16L24.412 22.785"
                stroke={color}
                strokeWidth="2"
                strokeMiterlimit="10"
            />
        </g>
        <defs>
            <clipPath id="clip0_9520_39642">
                <rect width="32" height="32" fill={color} />
            </clipPath>
        </defs>
    </svg>
);
